<div class="flex flex-col w-full mb-4">
  <label
    *ngIf="label"
    [attr.for]="id"
    class="block mb-2 text-gray-900 body-small-regular"
    >{{ label }}
    
    @if (isRequiredLabel) {
      <span class="text-red-400">&nbsp;*</span>
    }
  </label
  >
  <div class="relative">
    <div
      *ngIf="startIcon"
      class="absolute inset-y-0 flex items-center text-gray-400 pointer-events-none start-0 ps-3"
    >
      <span class="material-symbols-rounded">{{ startIcon }}</span>
    </div>
    <input
      [(ngModel)]="value"
      [attr.id]="id"
      [attr.name]="id"
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="isReadOnly"
      [maxlength]="maxLength"
      class="block w-full py-3 pl-3 pr-10 text-gray-900 border-0 rounded-md outline-none ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-brand-orange sm:text-sm sm:leading-6"
      [class.ps-10]="startIcon"
      (input)="onInputChange($event)"
      (blur)="onTouched()"
    />
  </div>
</div>
